import {types} from 'mobx-state-tree';
import CachedMessageModel from './branches/cachedMessageModel';
import InflightTextMessageModel from './branches/inflightMessageModel';
import SyncedMessageModel from './branches/syncedMessageModel';

const ChannelMessageModel = types.union(CachedMessageModel, InflightTextMessageModel, SyncedMessageModel);

export type ChannelMessage = typeof ChannelMessageModel.Type;

export default ChannelMessageModel;



// WEBPACK FOOTER //
// ./src/models/chatChannelModel/message/channelMessageModel.ts